import { useCallback, type VoidFunctionComponent } from 'react';

import ModalEditDependency from '../../../modals/ModalEditDependency';

/**
 * @param {string} userRevisionLocator - optional user project; (aka parent revision)
 * @param {string | null} dependencyLocatorToEdit - the dependency locator to edit
 * @param {(locator: string | null) => void} setDependencyLocatorToEdit - setter for dependency locator to edit
 */
type Props = {
  // optional user dependency - the parent revision
  userRevisionLocator?: string;
  // the currently selected dependency locator
  dependencyLocatorToEdit: string | null;
  // callback for setting/unsetting the dependency locator to edit
  setDependencyLocatorToEdit: (locator: string | null) => void;
};

const EditDependency: VoidFunctionComponent<Props> = ({
  userRevisionLocator,
  dependencyLocatorToEdit,
  setDependencyLocatorToEdit,
}) => {
  const onClose = useCallback(() => {
    // Reset the dependency locator to hide the modal
    setDependencyLocatorToEdit(null);
  }, [setDependencyLocatorToEdit]);

  if (!dependencyLocatorToEdit) {
    return null;
  }

  return (
    <ModalEditDependency
      show={dependencyLocatorToEdit != null}
      onHide={onClose}
      onChange={onClose}
      revisionLocator={dependencyLocatorToEdit}
      parentRevisionLocator={userRevisionLocator}
    />
  );
};

export default EditDependency;
